// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commandes-page {
  width: 100%;
  padding: 2rem;
}

.status-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: white;
  width: fit-content;
  padding: 1rem;
  border-radius: 50px;
}

.commandes-section {
  margin-top: 3rem;
}

/* .commandes-page h2 {
  font-size:3.2rem;
} */

/* .tableau-de-bord-section {
    border: 2px solid #2C3948;
    border-radius: 10px;
    padding: 2rem;
} */

.tableau-de-bord-section h1 {
  margin-bottom: 0;
}

/* Header avec titre à gauche et message à droite */
.commandes-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  margin-bottom: 2rem;
}

.commandes-header h1 {
  margin-bottom: 0;
}

.commandes-header .commandes-actions {
  flex-shrink: 0;
}

/* Espacement égal au-dessus et en-dessous de la barre de recherche/boutons */
.commandes-page .button-group {
  margin-top: 0;
  margin-bottom: 3rem;
}

/* Espacement sous les tabs pour équilibrer */
.commandes-page .tab-nav {
  margin-bottom: 3rem;
}

.page-header.client-view .buttons-container {
  /* display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  width: 100%; */
}

.page-header .buttons-container {
  /* margin: 0 0 2.5rem 0; */
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header.client-view {
  /* flex-direction: column; */
  /* align-items: flex-start; */
  gap: 2rem;
  width: 100%;
}

.montant-commande {
  font-weight: 700;
  text-align: right !important;
  white-space: nowrap;
}
/* new styles */

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.2rem;
  border-radius: 2rem;
  font-size: 1.4rem;
  font-weight: 700;
}

.status-badge.valider,
.status-badge.accept- {
  color: #00a708;
}

.status-badge.brouillons,
.status-badge.brouillon-prestataire,
.status-badge.brouillon-acheteur {
  color: #6b7280;
}

.status-badge.action-requise {
  color: #f4751b;
}

.status-badge.refuser,
.status-badge.refuse {
  color: #d90e0e;
}

.status-badge.expirer {
  color: #d90e0e;
}

.status-badge.en-attente-de-signature,
.status-badge.en-attente-de-l-analyse,
.status-badge.en-attente-de-lanalyse,
.status-badge.brouillon,
.status-badge.en-attente-des-candidatures,
.status-badge.en-attente-de-decision-de-l-acheteur,
.status-badge.en-attente-de-decision-de-lacheteur,
.status-badge[class*="en-attente-"] {
  color: #6b7280;
}

.status-badge.inconnu {
  color: #e5e7eb;
}

.tableau-container {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.tableau th {
  padding: 1rem;
  background-color: #f9f9f9;
  position: relative;
  cursor: pointer;
}

.sort-icon {
  position: absolute;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
}

.action-button {
  border-radius: 20px;
  padding: 8px 20px;
  font-weight: 600;
}

.action-button.action-requise {
  background-color: #da7027;
  color: #fffdfc;
  border: none;
}

.action-button.action-requise:hover {
  background-color: #b24c26;
  color: #fffdfc;
  border: none;
}

.countdown {
  color: #da7027;
  font-weight: 600;
}

td .action-button {
  font-size: 1.2rem !important;
  width: 140px;
}

td .countdown {
  border-width: 1px !important;
  font-size: 1.1rem;
  white-space: nowrap;
}

td .commande-nom {
  min-width: 150px;
}

/* Style pour tronquer le texte qui dépasse */
.lot-technique.text-truncate {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* Ajoutez un titre (tooltip) qui apparaît au survol pour voir le texte complet */
.lot-technique.text-truncate:hover {
  position: relative;
}

/* Ajouter à Commandes.css */
.text-truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  max-height: 2.8em; /* ~2 lines */
  line-height: 1.4em;
  max-width: 150px;
}

.client-info,
.lot-technique,
.lot-geographique,
.user-info,
.commande-nom,
.date-info,
.type-info {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.4em;
}

.tableau-container td {
  vertical-align: top;
  padding: 4px 6px;
}

/* Pour assurer que les points de suspension s'affichent correctement */
.tableau-container td > div {
  position: relative;
  width: 100%;
}

td .button {
  padding: 0.5rem !important;
}

.bc-absent-message {
  background-color: white;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-top: 2rem;
  font-size: 1.2rem;
}

.bc-absent-message p {
  margin: 0;
  line-height: 1.4;
}

/* Loading Indicator */
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.loading-indicator .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #da7027;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-indicator p {
  color: #6b7280;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 0;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: 20px;
  background-color: #fef2f2;
  border-radius: 8px;
  margin-top: 1rem;
}

.error-message p {
  color: #dc2626;
  font-size: 1.4rem;
  font-weight: 500;
  margin: 0;
}

/* Bouton de suppression pour les brouillons */
.delete-brouillon-btn {
  width: 2.4rem;
  height: 2.4rem;
  border: none;
  background-color: transparent;
  color: #dc2626;
  border-radius: 50%;
  font-size: 2rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease;
  line-height: 1;
}

.delete-brouillon-btn:hover {
  background-color: #fee2e2;
  color: #b91c1c;
}

.delete-brouillon-btn:active {
  background-color: #fecaca;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Commandes/Commandes.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;gBAIc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,eAAe;;AAEf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".commandes-page {\r\n  width: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n.status-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  background-color: white;\r\n  width: fit-content;\r\n  padding: 1rem;\r\n  border-radius: 50px;\r\n}\r\n\r\n.commandes-section {\r\n  margin-top: 3rem;\r\n}\r\n\r\n/* .commandes-page h2 {\r\n  font-size:3.2rem;\r\n} */\r\n\r\n/* .tableau-de-bord-section {\r\n    border: 2px solid #2C3948;\r\n    border-radius: 10px;\r\n    padding: 2rem;\r\n} */\r\n\r\n.tableau-de-bord-section h1 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Header avec titre à gauche et message à droite */\r\n.commandes-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.commandes-header h1 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.commandes-header .commandes-actions {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Espacement égal au-dessus et en-dessous de la barre de recherche/boutons */\r\n.commandes-page .button-group {\r\n  margin-top: 0;\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n/* Espacement sous les tabs pour équilibrer */\r\n.commandes-page .tab-nav {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.page-header.client-view .buttons-container {\r\n  /* display: flex;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%; */\r\n}\r\n\r\n.page-header .buttons-container {\r\n  /* margin: 0 0 2.5rem 0; */\r\n}\r\n\r\n.page-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.page-header.client-view {\r\n  /* flex-direction: column; */\r\n  /* align-items: flex-start; */\r\n  gap: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n.montant-commande {\r\n  font-weight: 700;\r\n  text-align: right !important;\r\n  white-space: nowrap;\r\n}\r\n/* new styles */\r\n\r\n.status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.4rem 1.2rem;\r\n  border-radius: 2rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.status-badge.valider,\r\n.status-badge.accept- {\r\n  color: #00a708;\r\n}\r\n\r\n.status-badge.brouillons,\r\n.status-badge.brouillon-prestataire,\r\n.status-badge.brouillon-acheteur {\r\n  color: #6b7280;\r\n}\r\n\r\n.status-badge.action-requise {\r\n  color: #f4751b;\r\n}\r\n\r\n.status-badge.refuser,\r\n.status-badge.refuse {\r\n  color: #d90e0e;\r\n}\r\n\r\n.status-badge.expirer {\r\n  color: #d90e0e;\r\n}\r\n\r\n.status-badge.en-attente-de-signature,\r\n.status-badge.en-attente-de-l-analyse,\r\n.status-badge.en-attente-de-lanalyse,\r\n.status-badge.brouillon,\r\n.status-badge.en-attente-des-candidatures,\r\n.status-badge.en-attente-de-decision-de-l-acheteur,\r\n.status-badge.en-attente-de-decision-de-lacheteur,\r\n.status-badge[class*=\"en-attente-\"] {\r\n  color: #6b7280;\r\n}\r\n\r\n.status-badge.inconnu {\r\n  color: #e5e7eb;\r\n}\r\n\r\n.tableau-container {\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tableau th {\r\n  padding: 1rem;\r\n  background-color: #f9f9f9;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.sort-icon {\r\n  position: absolute;\r\n  right: -1px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.action-button {\r\n  border-radius: 20px;\r\n  padding: 8px 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.action-button.action-requise {\r\n  background-color: #da7027;\r\n  color: #fffdfc;\r\n  border: none;\r\n}\r\n\r\n.action-button.action-requise:hover {\r\n  background-color: #b24c26;\r\n  color: #fffdfc;\r\n  border: none;\r\n}\r\n\r\n.countdown {\r\n  color: #da7027;\r\n  font-weight: 600;\r\n}\r\n\r\ntd .action-button {\r\n  font-size: 1.2rem !important;\r\n  width: 140px;\r\n}\r\n\r\ntd .countdown {\r\n  border-width: 1px !important;\r\n  font-size: 1.1rem;\r\n  white-space: nowrap;\r\n}\r\n\r\ntd .commande-nom {\r\n  min-width: 150px;\r\n}\r\n\r\n/* Style pour tronquer le texte qui dépasse */\r\n.lot-technique.text-truncate {\r\n  max-width: 100px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n}\r\n\r\n/* Ajoutez un titre (tooltip) qui apparaît au survol pour voir le texte complet */\r\n.lot-technique.text-truncate:hover {\r\n  position: relative;\r\n}\r\n\r\n/* Ajouter à Commandes.css */\r\n.text-truncate {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  max-height: 2.8em; /* ~2 lines */\r\n  line-height: 1.4em;\r\n  max-width: 150px;\r\n}\r\n\r\n.client-info,\r\n.lot-technique,\r\n.lot-geographique,\r\n.user-info,\r\n.commande-nom,\r\n.date-info,\r\n.type-info {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  line-height: 1.4em;\r\n}\r\n\r\n.tableau-container td {\r\n  vertical-align: top;\r\n  padding: 4px 6px;\r\n}\r\n\r\n/* Pour assurer que les points de suspension s'affichent correctement */\r\n.tableau-container td > div {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\ntd .button {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n.bc-absent-message {\r\n  background-color: white;\r\n  padding: 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n  margin-top: 2rem;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.bc-absent-message p {\r\n  margin: 0;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Loading Indicator */\r\n.loading-indicator {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem 2rem;\r\n  min-height: 300px;\r\n  background-color: #f9fafb;\r\n  border-radius: 8px;\r\n  margin-top: 1rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.loading-indicator .spinner {\r\n  width: 48px;\r\n  height: 48px;\r\n  border: 4px solid #e5e7eb;\r\n  border-top-color: #da7027;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-indicator p {\r\n  color: #6b7280;\r\n  font-size: 1.6rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* Error Message */\r\n.error-message {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem;\r\n  min-height: 20px;\r\n  background-color: #fef2f2;\r\n  border-radius: 8px;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.error-message p {\r\n  color: #dc2626;\r\n  font-size: 1.4rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* Bouton de suppression pour les brouillons */\r\n.delete-brouillon-btn {\r\n  width: 2.4rem;\r\n  height: 2.4rem;\r\n  border: none;\r\n  background-color: transparent;\r\n  color: #dc2626;\r\n  border-radius: 50%;\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n  line-height: 1;\r\n}\r\n\r\n.delete-brouillon-btn:hover {\r\n  background-color: #fee2e2;\r\n  color: #b91c1c;\r\n}\r\n\r\n.delete-brouillon-btn:active {\r\n  background-color: #fecaca;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
